var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useState } from "react";
import { get } from "../utils/http";
import { ElfsightPopup, Modal } from "./Popups";
import { useNavigate } from "react-router-dom";
export var Link = function (props) {
    var navigation = useNavigate();
    var values = MapProperties(props);
    //HTML Data
    var href = values.href, target = values.target, onClick = values.onClick, label = values.label, children = values.children;
    //Game Data
    var gameRule = values.gameRule, gameRuleCooldown = values.gameRuleCooldown;
    //Comet Chat
    var CometChatID = values.CometChatID, CometChatUserID = values.CometChatUserID;
    //Modal Data
    var elfsightPopupID = values.elfsightPopupID, modal = values.modal, modalOverrides = values.modalOverrides;
    //Position Data
    var position = values.position, width = values.width, height = values.height, left = values.left, top = values.top;
    // Room Data
    var roomName = values.roomName, isExternal = values.isExternal, gaAction = values.gaAction, hoverMessage = values.hoverMessage;
    var optionals = {};
    var extras = {};
    var _a = useState(false), modalVisible = _a[0], toggleModal = _a[1];
    var isRedirectTrackingLink = !isExternal && (href === null || href === void 0 ? void 0 : href.length) && !href.startsWith("http") && !href.startsWith("/");
    var generatedOnClick = function () { };
    if (modal) {
        // eslint-disable-next-line no-param-reassign
        generatedOnClick = function () {
            toggleModal(!modalVisible);
        };
    }
    else if (CometChatID) {
        // eslint-disable-next-line no-param-reassign
        generatedOnClick = function () {
            window.CometChatWidget.openOrCloseChat(true)(window).CometChatWidget.chatWithGroup(CometChatID);
        };
    }
    else if (CometChatUserID) {
        // eslint-disable-next-line no-param-reassign
        generatedOnClick = function () {
            window.CometChatWidget.openOrCloseChat(true)(window).CometChatWidget.chatWithUser(CometChatUserID);
        };
    }
    else if (isRedirectTrackingLink) {
        // eslint-disable-next-line no-param-reassign
        generatedOnClick = function () {
            window.redirectTracking(href, 1);
        };
    }
    if (!isRedirectTrackingLink && href) {
        if (isExternal)
            optionals.href = href;
        else
            extras.href = function () {
                navigation(href);
            };
    }
    var className = roomName ? "_gtm-event" : "";
    return React.createElement(React.Fragment, null,
        React.createElement("a", __assign({ key: "".concat(label, "-").concat(roomName), target: target, onClick: function () {
                if (onClick) {
                    onClick();
                    generatedOnClick();
                }
                if (gameRule) {
                    triggerGamificationRule(gameRule, gameRuleCooldown);
                }
                if (extras.href) {
                    extras.href();
                }
            }, "data-text": hoverMessage, id: label, "data-event-category": roomName, "data-event-action": gaAction, "data-event-label": label, title: label, "aria-label": label, className: className, style: { position: position, width: width, height: height, left: left, top: top, cursor: "pointer", textDecorator: "none" } }, optionals), children),
        modal && modalVisible && React.createElement(Modal, __assign({}, modalOverrides, { dismiss: function () { return toggleModal(false); } }), modal),
        elfsightPopupID && React.createElement(ElfsightPopup, { ID: elfsightPopupID }));
};
export var Links = function (_a) {
    var links = _a.links, roomName = _a.roomName;
    return React.createElement(React.Fragment, null, links.map(function (link) { return React.createElement(Link, __assign({}, link, { key: link.label, roomName: roomName })); }));
};
function MapProperties(props) {
    return __assign({ href: null, target: null, onClick: function () { return null; }, elfsightPopupID: null, modal: null, CometChatID: null, CometChatUserID: null, children: null, position: "absolute", isExternal: undefined, gameRule: null, gameRuleCooldown: 0, modalOverrides: {}, gaAction: "Link Click", hoverMessage: null }, props);
}
// Debounce is in milliseconds so a 1hr cooldown
//  on a rule activation would be 1000 * 60 * 60
export var triggerGamificationRule = function (actionName, debounce) {
    if (debounce === void 0) { debounce = 0; }
    var eventId = window.dataLayer[0]["Event ID"];
    var regId = window.dataLayer[0]["Registrant ID"];
    var firstName = window.dataLayer[0]["First Name"];
    var lastName = window.dataLayer[0]["Last Name"];
    var email = window.dataLayer[0]["Email Address"];
    var optedIn = window.dataLayer[0]["I would like to opt in to the Leaderboard competition"] === "Yes";
    var lastTriggered = window.localStorage.getItem("rule-".concat(actionName)) || "2021";
    if (new Date() < new Date(parseInt(lastTriggered) / 1 + debounce)) {
        return;
    }
    else {
        window.localStorage.setItem("rule-".concat(actionName), new Date().valueOf().toString());
    }
    var registrantId = "".concat(regId, "_").concat(firstName, "_").concat(lastName, "_").concat(email);
    var query = { actionName: actionName, eventId: eventId, registrantId: registrantId, swoogoAccess: false };
    if (optedIn) {
        get("https://sponsor-gamification.herokuapp.com/dynamic", query);
    }
};
//# sourceMappingURL=Link.js.map